// extracted by mini-css-extract-plugin
export default {"mixlr-footer":"styles_mixlr-footer__OREly","mixlr-footer__logo":"styles_mixlr-footer__logo__Esil2"};